import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, roleHome } from "../lib/auth";
import { MediGenieLogo } from "../components/MediGenieLogo";
import { Mascot } from "../components/Mascot";
import { toast } from "sonner";
import { apiErrorMessage } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const pharmacy = new URLSearchParams(window.location.search).get("workspace") === "pharmacy";

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password, pharmacy ? "pharmacy" : "clinical");
      toast.success(`Welcome back, ${u.name}!`);
      const next = new URLSearchParams(window.location.search).get("next");
      if (pharmacy && !u.must_change_password && next && /^\/pharmacies\/[^/\\]+\/(?:upload-prescription(?:\?cart=1)?|checkout)$/.test(next)) { nav(next); return; }
      nav(u.must_change_password ? "/my-profile" : pharmacy ? (u.pharmacy_workspace_available ? "/pharmacy-panel" : u.role === "patient" ? "/my-account" : "/pharmacy-orders") : u.role === "patient" ? "/my-account" : roleHome(u.role));
    } catch (err) {
      toast.error(apiErrorMessage(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 mg-gradient-primary text-white p-12 flex-col justify-between relative overflow-hidden">
        <div />
        <div>
          <div className="flex justify-center mb-6"><Mascot size={420} className="mg-float max-h-[55vh]" /></div>
          <h2 className="text-3xl font-extrabold text-center">Healthcare with a little magic ✨</h2>
          <p className="text-center text-blue-100 mt-3 max-w-md mx-auto">
            One platform for appointments, encounters, prescriptions, billing and follow-ups.
          </p>
        </div>
        <div className="text-xs text-blue-200">© {new Date().getFullYear()} MediGenie</div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link to="/" className="flex justify-center mb-8"><MediGenieLogo size={64} /></Link>
          <h1 className="text-3xl font-extrabold text-mg-navy" data-testid="login-title">Welcome back</h1>
          <p className="text-slate-500 mt-1">{pharmacy ? "Sign in to shop, upload prescriptions and track your orders" : "Sign in to continue to MediGenie"}</p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="login-form">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
              <input
                type="email" autoComplete="email" aria-label="Email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="mg-input"
                data-testid="login-email"
              />
            </div>
            <div>
              <div className="flex items-center justify-between mb-1.5"><label className="text-sm font-medium text-slate-700">Password</label><Link to="/forgot-password" className="text-sm font-semibold text-mg-medical" data-testid="login-forgot-password-link">Forgot password?</Link></div>
              <input
                type="password" autoComplete="current-password" aria-label="Password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mg-input"
                data-testid="login-password"
              />
            </div>
            <button type="submit" disabled={loading} className="mg-btn-primary w-full justify-center" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-6 grid grid-cols-2 gap-3 text-center text-sm">
            <Link to={"/register/patient" + (pharmacy ? window.location.search : "")} className="rounded-xl border border-blue-200 bg-blue-50 p-3 font-semibold text-mg-medical">{pharmacy ? "Register with email" : "Register as patient"}</Link>
            <Link to="/join-our-team" className="rounded-xl border border-slate-200 p-3 font-semibold text-mg-navy">Join Our Team</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
